/**
 * playerName — how a player's name is shortened for a narrow column.
 *
 * "Ja'Marr Chase" -> "J. Chase", "Marvin Harrison Jr." -> "M. Harrison Jr.".
 *
 * 🔴 EVERYTHING AFTER THE FIRST TOKEN IS KEPT, VERBATIM. Suffixes and compound
 * surnames are part of who somebody is, and a rule that dropped the tail would
 * turn two different players into one row: the pool holds both a "Marvin
 * Harrison Jr." and names that differ only past the second token.
 *
 * 🔴 IT IS A DISPLAY FUNCTION AND NOTHING ELSE. Never match, sort, key or store
 * on the output. `${name}-${pos}` is the composite key everywhere in this app
 * and an initial cannot reconstruct it, so a short name that reached a lookup
 * would miss silently rather than throw.
 *
 * NOT a merge of the private copies in ProjectionResults.jsx and TeamEditor.jsx.
 * Those return an em dash for a missing name because they render into a table
 * cell that must not collapse; this returns "" because a caller who wants a
 * placeholder can say so and one who does not should not inherit one.
 */
export function shortName(name) {
  if (!name) return "";
  const parts = String(name).trim().split(/\s+/);
  if (parts.length < 2) return parts[0] || "";
  return `${parts[0][0]}. ${parts.slice(1).join(" ")}`;
}

export default shortName;
